<template>
  <div class="fullbox" @click="deleBlur($event)">
    <div class="top">
      <div class="search_left">
        <div class="date-container">
          <el-date-picker
            v-model="valueMonth"
            ref="pickerCtrl"
            type="date"
            placeholder="选择月"
            class="date-picker-ctrl"
            @change="pickerChange"
            :picker-options="setDisabled"
          >
          </el-date-picker>
          <div class="month-text" @click="showPickerCtrl">
            {{ monthText }}
            <span class="el-icon-caret-bottom date-icon"></span>
          </div>
          <div style="font-size: 14px; margin: -3px 5px 0">
            ({{ textToday }})
          </div>
        </div>
        <div class="date_set">
          <span
            v-if="valueMonth == dayMonth"
            class="el-icon-arrow-left date1"
          ></span>
          <span
            v-else
            class="el-icon-arrow-left date2"
            @click="deleDate"
          ></span>
          <span class="el-icon-arrow-right date3" @click="addDate"></span>
        </div>
        <div
          style="
            margin-left: 10px;
            color: #000;
            font-weight: bold;
            font-size: 15px;
          "
        >
          活动室：{{ urlName }}
        </div>
      </div>
      <!-- <div class="search_right" @click="myReserDialog = true">
        <span class="el-icon-wallet date1"></span>
        我的预定
      </div> -->
      <div class="search_right" @click="toUrl">
        <i class="el-icon-house" style="margin-right: 5px; font-size: 18px"></i>
        返回主页
      </div>
    </div>
    <div class="content" :style="contentStyle">
      <div
        v-for="(item, ind) in list"
        :key="item.activityAreaId"
        style="position: relative"
      >
        <div class="title">
          {{ item.activityAreaName }}
        </div>
        <div
          style="
            position: absolute;
            left: -4px;
            top: 56px;
            color: #999;
            font-size: 14px;
          "
        >
          8
        </div>
        <div class="con_list">
          <div
            v-for="(v, i) in item.zjTimeList"
            :key="v.time"
            style="position: relative"
          >
            <div
              class="no_box"
              :class="{
                ctime: timeList.includes(v.time),
                ztime: v.ztime,
                jtime: v.result?.scheduledUser == store.userInfo.nickname,
                bClss: i % 2 == 0,
              }"
              @click="showBlueBox(i, $event, ind, v)"
              ref="no_box_ref"
              :style="itemStyle"
            ></div>
            <div class="text" v-if="v.showText">{{ v.time }}</div>
          </div>
        </div>
        <div
          class="con_menu"
          :style="conMenuStyle"
          @click="triggerFirstBoxClick"
        ></div>
        <!-- <div class="menu"></div> -->
      </div>
      <div
        v-if="blueBoxVisible"
        class="blue-box"
        :style="blueBoxStyle"
        ref="blue-box"
      >
        <div
          class="resize-handle-left"
          @mousedown="startResize('left', $event)"
          @mouseup="handleMouseUp($event, 'left')"
        >
          <div class="circle"></div>
        </div>
        <div
          class="resize-handle-right"
          @mousedown="startResize('right', $event)"
          @mouseup="handleMouseUp($event, 'right')"
        >
          <div class="circle"></div>
        </div>
      </div>
    </div>
    <div class="ztimeMenu" :style="ztimeMenuStyle" v-if="ztimeMenuShow">
      <div style="margin-bottom: 6px">
        <span class="s1">{{ ztimeMenuList?.scheduledUser }}</span>
        已预定
      </div>
      <div>
        {{ cText }}
        <span style="margin: 0 5px">{{ checkDate2(valueMonth) }}</span>
        {{ formatTime(ztimeMenuList?.scheduledTime) }}
      </div>
    </div>

    <div
      class="ctimeMenu"
      :style="ctimeMenuStyle"
      v-if="ctimeMenuShow"
      @click.stop="setCtimeShow"
    >
      <div style="margin-bottom: 6px" class="s1">
        {{ ctimeMenuList.activityAreaName }}
      </div>
      <div>
        {{ cText }}
        <span style="margin: 0 5px">{{ checkDate2(valueMonth) }}</span>
        <span v-if="startTime.time">
          {{ formatTime(`${startTime.time}-${endTime.time}`) }}
        </span>
      </div>
      <el-button
        :disabled="disabledReserv"
        class="reserv-btn"
        @click="okReservation"
        >预定</el-button
      >
    </div>
    <dialogMyReser :valueMonth="valueMonth" :visible.sync="myReserDialog" />
    <!-- <dialogSubmit
      :visible.sync="submitDialog"
      :ctimeMenuList="ctimeMenuList"
      :startTime="startTime.time"
      :endTime="endTime.time"
      :cText="cText"
      :valueMonth="valueMonth"
      :urlName="urlName"
      :urlId="urlId"
      @changeUpload="changeUpload"
      type="1"
    /> -->
  </div>
</template>

<script>
import moment from "moment";
import dialogMyReser from "./dialogMyReser.vue";
// import dialogSubmit from "./submit.vue";
import api from "@/apis/reservation";
import { uncompress } from "@/utils/tools";
// import api from "@/apis";
// import { setToken, getToken } from "@/utils/cookie";
export default {
  name: "app",
  components: {
    dialogMyReser,
    // dialogSubmit,
  },
  data() {
    return {
      valueMonth: moment(new Date()).format("YYYY-MM-DD"),
      dayMonth: moment(new Date()).format("YYYY-MM-DD"),
      textToday: "今天",
      setDisabled: {
        disabledDate(time) {
          return time.getTime() < moment().startOf("day").valueOf();
        },
      },
      timeListDom: [
        // {
        //   time: "0",
        //   showText: true,
        // },
        // {
        //   time: "0:30",
        //   startTime: "0",
        //   showText: false,
        // },
        // {
        //   time: "1",
        //   startTime: "0:30",
        //   showText: true,
        // },
        // {
        //   time: "1:30",
        //   startTime: "1",
        //   showText: false,
        // },
        // {
        //   time: "2",
        //   startTime: "1:30",
        //   showText: true,
        // },
        // {
        //   time: "2:30",
        //   startTime: "2",
        //   showText: false,
        // },
        // {
        //   time: "3",
        //   startTime: "2:30",
        //   showText: true,
        // },
        // {
        //   time: "3:30",
        //   startTime: "3",
        //   showText: false,
        // },
        // {
        //   time: "4",
        //   startTime: "3:30",
        //   showText: true,
        // },
        // {
        //   time: "4:30",
        //   startTime: "4",
        //   showText: false,
        // },
        // {
        //   time: "5",
        //   startTime: "4:30",
        //   showText: true,
        // },
        // {
        //   time: "5:30",
        //   startTime: "5",
        //   showText: false,
        // },
        // {
        //   time: "6",
        //   startTime: "5:30",
        //   showText: true,
        // },
        // {
        //   time: "6:30",
        //   startTime: "6",
        //   showText: false,
        // },
        // {
        //   time: "7",
        //   startTime: "6:30",
        //   showText: true,
        // },
        // {
        //   time: "7:30",
        //   startTime: "7",
        //   showText: false,
        // },
        // {
        //   time: "8",
        //   startTime: "7:30",
        //   showText: true,
        // },
        {
          time: "8:30",
          startTime: "8",
          showText: false,
        },
        {
          time: "9",
          startTime: "8:30",
          showText: true,
        },
        {
          time: "9:30",
          startTime: "9",
          showText: false,
        },
        {
          time: "10",
          startTime: "9:30",
          showText: true,
        },
        {
          time: "10:30",
          startTime: "10",
          showText: false,
        },
        {
          time: "11",
          startTime: "10:30",
          showText: true,
        },
        {
          time: "11:30",
          startTime: "11",
          showText: false,
        },
        {
          time: "12",
          startTime: "11:30",
          showText: true,
        },
        {
          time: "12:30",
          startTime: "12",
          showText: false,
        },
        {
          time: "13",
          startTime: "12:30",
          showText: true,
        },
        {
          time: "13:30",
          startTime: "13",
          showText: false,
        },
        {
          time: "14",
          startTime: "13:30",
          showText: true,
        },
        {
          time: "14:30",
          startTime: "14",
          showText: false,
        },
        {
          time: "15",
          startTime: "14:30",
          showText: true,
        },
        {
          time: "15:30",
          startTime: "15",
          showText: false,
        },
        {
          time: "16",
          startTime: "15:30",
          showText: true,
        },
        {
          time: "16:30",
          startTime: "16",
          showText: false,
        },
        {
          time: "17",
          startTime: "16:30",
          showText: true,
        },
        {
          time: "17:30",
          startTime: "17",
          showText: false,
        },
        {
          time: "18",
          startTime: "17:30",
          showText: true,
        },
        {
          time: "18:30",
          startTime: "18",
          showText: false,
        },
        {
          time: "19",
          startTime: "18:30",
          showText: true,
        },
        {
          time: "19:30",
          startTime: "19",
          showText: false,
        },
        {
          time: "20",
          startTime: "19:30",
          showText: true,
        },
        {
          time: "20:30",
          startTime: "20",
          showText: false,
        },
        {
          time: "21",
          startTime: "20:30",
          showText: true,
        },
        {
          time: "21:30",
          startTime: "21",
          showText: false,
        },
        {
          time: "22",
          startTime: "21:30",
          showText: true,
        },
        // {
        //   time: "22:30",
        //   startTime: "22",
        //   showText: false,
        // },
        // {
        //   time: "23",
        //   startTime: "22:30",
        //   showText: true,
        // },
        // {
        //   time: "23:30",
        //   startTime: "23",
        //   showText: false,
        // },
        // {
        //   time: "24",
        //   startTime: "23:30",
        //   showText: true,
        // },
      ],
      valueStartTime: "请选择",
      valueTimeLength: "请选择",
      valueTimeText: "不限时间段",
      optionStartTime: [
        { label: "00:00", value: "0" },
        { label: "00:30", value: "0:30" },
        { label: "01:00", value: "1" },
        { label: "01:30", value: "1:30" },
        { label: "02:00", value: "2" },
        { label: "02:30", value: "2:30" },
        { label: "03:00", value: "3" },
        { label: "03:30", value: "3:30" },
        { label: "04:00", value: "4" },
        { label: "04:30", value: "4:30" },
        { label: "05:00", value: "5" },
        { label: "05:30", value: "5:30" },
        { label: "06:00", value: "6" },
        { label: "06:30", value: "6:30" },
        { label: "07:00", value: "7" },
        { label: "07:30", value: "7:30" },
        { label: "08:00", value: "8" },
        { label: "08:30", value: "8:30" },
        { label: "09:00", value: "9" },
        { label: "09:30", value: "9:30" },
        { label: "10:00", value: "10" },
        { label: "10:30", value: "10:30" },
        { label: "11:00", value: "11" },
        { label: "11:30", value: "11:30" },
        { label: "12:00", value: "12" },
        { label: "12:30", value: "12:30" },
        { label: "13:00", value: "13" },
        { label: "13:30", value: "13:30" },
        { label: "14:00", value: "14" },
        { label: "14:30", value: "14:30" },
        { label: "15:00", value: "15" },
        { label: "15:30", value: "15:30" },
        { label: "16:00", value: "16" },
        { label: "16:30", value: "16:30" },
        { label: "17:00", value: "17" },
        { label: "17:30", value: "17:30" },
        { label: "18:00", value: "18" },
        { label: "18:30", value: "18:30" },
        { label: "19:00", value: "19" },
        { label: "19:30", value: "19:30" },
        { label: "20:00", value: "20" },
        { label: "20:30", value: "20:30" },
        { label: "21:00", value: "21" },
        { label: "21:30", value: "21:30" },
        { label: "22:00", value: "22" },
        { label: "22:30", value: "22:30" },
        { label: "23:00", value: "23" },
        { label: "23:30", value: "23:30" },
      ],
      optionTimeLength: [
        {
          label: "请选择",
          value: "0",
        },
        {
          label: "30分钟",
          value: "1",
        },
        {
          label: "1小时",
          value: "2",
        },
        {
          label: "2小时",
          value: "4",
        },
        {
          label: "3小时",
          value: "6",
        },
      ],

      list: [],
      timeList: [],
      myReserDialog: false,
      submitDialog: false,
      disabledReserv: false, // 是否禁用预约
      items: Array.from({ length: 48 }),
      itemWidth: 0,
      itemHeight: 23,
      blueBoxVisible: false,
      blueBoxStyle: {
        top: "0px",
        left: "0px",
        width: "0px",
        height: "40px",
      },
      startX: 0,
      resizing: false,
      resizeDirection: null,
      contentStyle: {
        position: "relative",
        margin: "10px",
        mar: 10,
      },
      indexList: [],
      startTime: {},
      endTime: {},
      ind: "",

      urlName: "",
      urlId: "",
      ctimeMenuShow: false,
      ctimeMenuList: {},
      ctimeMenuStyle: {
        position: "absolute",
        top: 0,
        left: 0,
      },
      ztimeMenuShow: false,
      ztimeMenuList: {},
      ztimeMenuStyle: {
        position: "absolute",
        top: 0,
        left: 0,
      },
      conMenuStyle: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
      },
      store: {},
    };
  },
  computed: {
    //格式化时间
    monthText() {
      return moment(this.valueMonth).format("MM-DD");
    },
    //计算宽度&高度
    itemStyle() {
      return {
        width: `${this.itemWidth}px`,
        height: `${this.itemHeight}px`,
        float: "left",
        position: "relative",
      };
    },
    //格式化时间
    cText() {
      return moment(this.valueMonth).format("M月DD日");
    },
  },
  watch: {
    //监听月份变化
    valueMonth() {
      if (this.valueMonth == this.dayMonth) {
        const hh = moment(new Date()).format("H:mm");
        this.generateTimeList(hh);
      } else {
        this.generateTimeList("0:0");
      }
    },
  },
  created() {},
  mounted() {
    this.store = JSON.parse(localStorage.getItem("store"));
    const { name, id } = this.$route.query;
    this.urlName = name;
    this.urlId = id;
    this.calculateItemWidth();
    this.getList();
    this.getTreeList();
    window.addEventListener("resize", this.calculateItemWidth);
    if (this.valueMonth == this.dayMonth) {
      const hh = moment(new Date()).format("H:mm");
      console.log(hh, "hhh");
      this.generateTimeList(hh);
    }
  },
  //销毁时移除事件监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateItemWidth);
  },
  methods: {
    //跳转到主页
    toUrl() {
      this.$router.push("/mobReservation");
    },
    //计算宽度
    calculateItemWidth() {
      this.itemWidth = (window.innerWidth - this.contentStyle.mar * 2) / 28;
    },
    //点击预约，计算样式，跳转提交页面
    showBlueBox(index, e, ind, result) {
      const classList = e.target.classList;
      const ctime = e.target.getBoundingClientRect();
      if (classList.contains("ctime")) return;
      // if (classList.contains("ztime")) return;
      if (classList.contains("ztime")) {
        this.ztimeMenuStyle.left = `${ctime.left - 80}px`;
        this.ztimeMenuStyle.top = `${ctime.top - 80}px`;
        this.ztimeMenuList = result.result;
        this.$nextTick(() => {
          this.ztimeMenuShow = true;
        });
        return;
      }
      this.ctimeMenuList = this.list[ind];
      // this.startTime = this.list[ind].zjTimeList[index - 1];
      // this.endTime = this.list[ind].zjTimeList[index];
      this.$router.push({
        path: "/mobReservation/submit",
        query: {
          // url的参数, 类似get请求的传参
          ctimeMenuList: this.ctimeMenuList,
          startTime: this.startTime.time,
          endTime: this.endTime.time,
          cText: this.cText,
          valueMonth: this.valueMonth,
          urlName: this.urlName,
          urlId: this.urlId,
          type: "1",
        },
      });
      // this.blueBoxVisible = true;
      // this.ctimeMenuStyle.left = `${ctime.left - 80}px`;
      // this.ctimeMenuStyle.top = `${ctime.top + 40}px`;
      // this.ctimeMenuShow = true;
      // this.ind = ind;
      // this.startTime = this.list[ind].zjTimeList[index - 1];
      // this.endTime = this.list[ind].zjTimeList[index];
      // let targetElement = e.target;
      // // 获取元素距离视窗顶部的距离
      // let rect = targetElement.getBoundingClientRect();
      // // 获取页面当前的滚动偏移量
      // let scrollTop = window.pageYOffset;
      // // 计算元素距离页面顶部的距离
      // let distanceFromTop = rect.top + scrollTop - 75;
      // console.log(index, "index");

      // // const rowIndex = Math.floor(index / 48);
      // const columnIndex = index % 36;
      // // const top = rowIndex * this.itemHeight;
      // const left = columnIndex * this.itemWidth;
      // const width = this.itemWidth;
      // this.blueBoxStyle = {
      //   top: `${distanceFromTop}px`,
      //   left: `${left}px`,
      //   width: `${width}px`,
      //   height: `${this.itemHeight}px`,
      // };
      // this.indexList.push(index);
    },
    //按下鼠标，计算样式
    startResize(direction, event) {
      this.resizing = true;
      this.resizeDirection = direction;
      this.startX = event.clientX;
      event.preventDefault();
      console.log(event, "event");
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },
    //鼠标抬起，计算样式
    handleMouseUp(i, type) {
      const ev = Math.round((i.pageX - this.contentStyle.mar) / this.itemWidth);

      if (type === "right") {
        if (this.indexList.length > 1) {
          this.indexList[1] = ev;
        } else {
          this.indexList.push(ev);
        }
      } else {
        if (this.indexList.length > 1) {
          this.indexList[0] = ev;
        } else {
          this.indexList.unshift(ev);
        }
      }
      console.log(this.indexList, "indexlist", this.list[this.ind].zjTimeList);
      // this.startTime = this.list[this.ind].zjTimeList[this.indexList[0] - 1];
      // this.endTime = this.list[this.ind].zjTimeList[this.indexList[1] - 1];

      if (type === "left") {
        this.startTime = this.list[this.ind].zjTimeList[this.indexList[0] - 1];
        this.endTime = this.list[this.ind].zjTimeList[this.indexList[1]];
      } else {
        this.startTime = this.list[this.ind].zjTimeList[this.indexList[0] - 1];
        this.endTime = this.list[this.ind].zjTimeList[this.indexList[1] - 1];
      }

      const _startTime = this.startTime;
      const _endTime = this.endTime;
      console.log(
        this.list[this.ind].zjTimeList,
        "this.list[this.ind].zjTimeList"
      );

      const startIndex = this.list[this.ind].zjTimeList.findIndex(
        (item) => item.time === _startTime.time
      );
      const endIndex = this.list[this.ind].zjTimeList.findIndex(
        (item) => item.time === _endTime.time
      );
      const reservedList = this.list[this.ind].zjTimeList
        .map((item, ind) => {
          if (ind > startIndex && ind < endIndex && item.ztime) {
            return ind;
          }
        })
        .filter((item) => item);

      const obsoleteList = this.list[this.ind].zjTimeList
        .map((item, ind) => {
          if (
            ind >= ev &&
            ind <= endIndex &&
            this.timeList.includes(item.time)
          ) {
            return item;
          }
        })
        .filter((item) => item);
      if (reservedList.length || obsoleteList.length) {
        this.disabledReserv = true;
      } else {
        this.disabledReserv = false;
      }
    },
    //鼠标移动，计算样式
    onMouseMove(event) {
      const deltaX = event.clientX - this.startX;
      let newWidth;
      if (this.resizeDirection === "left") {
        newWidth = parseFloat(this.blueBoxStyle.width) - deltaX;
        this.blueBoxStyle.left = `${
          parseFloat(this.blueBoxStyle.left) + deltaX
        }px`;
      } else if (this.resizeDirection === "right") {
        newWidth = parseFloat(this.blueBoxStyle.width) + deltaX;
      }
      this.blueBoxStyle.width = `${newWidth}px`;
      this.startX = event.clientX;
    },
    //鼠标抬起，移除事件监听器
    onMouseUp() {
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
      this.resizing = false;
      this.resizeDirection = null;
    },
    //计算样式，鼠标移动
    handleMouseEnter(result, e) {
      const classList = e.target.classList;
      if (classList.contains("ztime")) {
        const rect = e.target.getBoundingClientRect();
        this.ztimeMenuStyle.left = `${rect.left - 80}px`;
        this.ztimeMenuStyle.top = `${rect.top - 80}px`;
        this.ztimeMenuList = result.result;
        this.$nextTick(() => {
          this.ztimeMenuShow = true;
        });
        console.log(result, "result");
      }
    },
    //重置状态
    handleMouseLeave() {
      this.ztimeMenuShow = false;
    },
    //点击时间，聚焦input框
    showPickerCtrl() {
      this.$refs["pickerCtrl"].focus();
    },
    //选择日期
    pickerChange(val) {
      this.valueMonth = moment(val).format("YYYY-MM-DD");
      this.checkDate(this.valueMonth);
      this.getList();
    },
    //删除日期
    deleDate() {
      if (this.valueMonth != this.dayMonth) {
        const yesterday = moment(this.valueMonth)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        this.valueMonth = yesterday;
        this.checkDate(this.valueMonth);
        this.getList();
      }
    },
    //增加日期
    addDate() {
      const yesterday = moment(this.valueMonth)
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.valueMonth = yesterday;
      this.checkDate(this.valueMonth);
      this.getList();
    },
    //查看日期
    checkDate(time) {
      const inputMoment = moment(time);
      const now = moment();
      const daysDiff = inputMoment.diff(now, "days");

      if (inputMoment.isSame(now, "day")) {
        this.textToday = "今天";
      } else if (daysDiff == 0) {
        this.textToday = "明天";
      } else if (daysDiff == 1) {
        this.textToday = "后天";
      } else if (daysDiff >= 2) {
        const weekDayNum = inputMoment.day();
        const weekDaysShort = [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六",
        ];
        this.textToday = weekDaysShort[weekDayNum];
      } else {
        this.textToday = "已过期";
      }
      return this.textToday;
    },
    //显示预约弹窗
    setCtimeShow() {
      this.ctimeMenuShow = true;
    },
    // 保存筛选
    clickBtnBc() {
      const index = this.timeListDom.findIndex(
        (item) => item.time == this.valueStartTime
      );
      const left = (index + 1) * this.itemWidth;
      const width = this.valueTimeLength * this.itemWidth;
      this.conMenuStyle = {
        position: "absolute",
        top: "30px",
        left: `${left}px`,
        height: `${this.itemHeight}px`,
        width: `${width}px`,
        // 'z-index':'-1',
        "pointer-events": "none",
      };
      this.valueTimeText = `${this.optionStartTime[index + 1].label}-${
        this.optionStartTime[index + 1 + parseInt(this.valueTimeLength)].label
      }`;
      this.$nextTick(() => {
        this.$refs.popoverRef.doClose();
      });
    },
    //选择时间段
    clickBtnCz() {
      this.valueStartTime = "请选择";
      this.valueTimeLength = "请选择";
      this.conMenuStyle = {
        position: "absolute",
        top: "0",
        left: `0`,
        height: `0`,
        width: `0`,
      };
      this.valueTimeText = `不限时间段`;
      this.$nextTick(() => {
        this.$refs.popoverRef.doClose();
      });
    },
    triggerFirstBoxClick(event) {
      // 阻止事件冒泡，防止第二个盒子的点击事件冒泡到第一个盒子
      event.stopPropagation();
      // 手动触发第一个盒子的点击事件
      this.$refs.no_box_ref.click();
    },
    //点击空白处，隐藏预约弹窗
    deleBlur(e) {
      const ev = e.target._prevClass;
      console.log(ev, "evevev");
      if (
        ev &&
        !ev.includes("no_box") &&
        ev != "resize-handle-right" &&
        ev != "resize-handle-left" &&
        ev != "circle"
      ) {
        this.blueBoxVisible = false;
        this.ctimeMenuShow = false;
        this.ztimeMenuShow = false;
        this.startTime = {};
        this.endTime = {};
        this.ind = "";
        this.indexList = [];
        this.disabledReserv = false;
      }
    },
    changeUpload() {
      this.getList();
    },
    //格式化时间
    generateTimeList(timeStr) {
      // 将时间字符串转换为小时和分钟
      const [hours, minutes] = timeStr.split(":").map(Number);

      // 初始化结果数组
      this.timeList = [];

      // 遍历从0到小时数（包含）
      for (let i = 0; i <= hours; i++) {
        // 添加整点时间（以单个数字表示）
        this.timeList.push(i.toString());

        // 如果不是最后一小时，或者最后一小时且分钟数大于等于30，则添加半点时间
        if (i < hours || (i === hours && minutes >= 30)) {
          this.timeList.push(`${i}:30`);
        }
        // 注意：如果最后一小时且分钟数小于30，则不添加该小时的半点时间
      }

      console.log(this.timeList, "this.timeList");

      return this.timeList;
    },

  //格式化时间
    checkDate2(time) {
      const inputMoment = moment(time);
      const now = moment();
      const daysDiff = inputMoment.diff(now, "days");
      const weekDayNum = inputMoment.day();
      const weekDaysShort = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ];
      const day = weekDaysShort[weekDayNum];
      let textToday;

      if (inputMoment.isSame(now, "day")) {
        textToday = `今天(${day})`;
      } else if (daysDiff == 0) {
        textToday = `明天(${day})`;
      } else if (daysDiff == 1) {
        textToday = `后天(${day})`;
      } else if (daysDiff >= 2) {
        textToday = `(${day})`;
      } else {
        textToday = "已过期";
      }
      return textToday;
    },
    //格式化时间范围
    formatTime(timeRange) {
      const [start, end] = timeRange?.split("-");
      const [startHour, startMinute = "00"] = start.split(":");
      const [endHour, endMinute = "00"] = end.split(":");

      const formattedStart = `${startHour.padStart(
        2,
        "0"
      )}:${startMinute.padStart(2, "0")}`;
      const formattedEnd = `${endHour.padStart(2, "0")}:${endMinute.padStart(
        2,
        "0"
      )}`;

      return `${formattedStart}-${formattedEnd}`;
    },

    // processTime(timeRange) {
    //   const times = timeRange.split("-");
    //   const startTime = times[0];
    //   const endTime = times[1];

    //   const startHourMinute = startTime.split(":");
    //   const endHourMinute = endTime.split(":");

    //   if (startHourMinute.length === 1 && endHourMinute.length === 1) {
    //     // 10-11
    //     return [`${startTime}:30`, endTime];
    //   } else if (startHourMinute.length === 2 && endHourMinute.length === 1) {
    //     // 10:30-11
    //     return [endTime];
    //   } else if (startHourMinute.length === 2 && endHourMinute.length === 2) {
    //     // 12:30-13:30
    //     return [endHourMinute[0], `${endHourMinute[0]}:${endHourMinute[1]}`];
    //   } else {
    //     return [];
    //   }
    // },

    // 处理时间范围
    processTime(range) {
      // 如果range是一个字符串，则转换为数组处理
      if (typeof range === "string") {
        range = [range];
      }

      let result = [];

      range.forEach((item) => {
        let times = item.split("-");

        // 处理开始时间
        let startTime = times[0].trim();
        let startHour = parseInt(startTime.split(":")[0], 10);
        let startMinute = parseInt(startTime.split(":")[1] || "0", 10);

        // 处理结束时间
        let endTime = times[1].trim();
        let endHour = parseInt(endTime.split(":")[0], 10);
        let endMinute = parseInt(endTime.split(":")[1] || "0", 10);

        // 生成时间段内所有时间点
        for (let hour = startHour; hour <= endHour; hour++) {
          for (
            let minute = hour === startHour ? startMinute : 0;
            minute <= (hour === endHour ? endMinute : 59);
            minute += 30
          ) {
            let formattedMinute = minute < 10 ? `0${minute}` : `${minute}`;
            result.push(`${hour}:${formattedMinute}`);
          }
        }
      });

      return result;
    },
    //获取列表数据
    getList() {
      const { id } = this.$route.query;
      // this.valueMonth
      api
        .queryPage({ activityRoomId: id, scheduledDate: this.valueMonth })
        .then((data) => {
          console.log(data, "data");
          let res = data.data.list;
          res.length > 0 &&
            res.forEach((item) => {
              item.zjTimeList = JSON.parse(JSON.stringify(this.timeListDom));
              item.timeList &&
                item.timeList.length > 0 &&
                item.timeList.forEach((v) => {
                  v.result = v.scheduledTime.split("-");
                  console.log(v.result, "v.result ");
                  const startIndex = item.zjTimeList.findIndex(
                    (item) => item.startTime === v.result[0]
                  );
                  const endIndex = item.zjTimeList.findIndex(
                    (item) => item.time === v.result[1]
                  );

                  item.zjTimeList.forEach((q, ind) => {
                    if (ind >= startIndex && ind <= endIndex) {
                      q.ztime = true;
                      q.result = v;
                    }
                  });
                });
            });
          console.log(res, "resss");
          this.list = res;
        });
    },
    //获取树形数据
    getTreeList() {
      const tree = localStorage.getItem("treeList");
      if (!tree) {
        api.userDirectory({ queryUserType: 1 }).then((data) => {
          const inflatedData = uncompress(data.data);
          localStorage.setItem("treeList", JSON.stringify(inflatedData));
          // console.log(inflatedData, "inflatedData");
          // this.treeList = inflatedData;
        });
      }
    },
    //点击预约
    okReservation() {
      this.submitDialog = true;
      this.ctimeMenuShow = false;
    },
  },
};
</script>

<style lang="scss">
.popClass {
  width: auto !important;
}
</style>

<style lang="scss" scoped>
.fullbox {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.top {
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  padding: 0 20px;
  .search_left {
    display: flex;
    align-items: center;
    position: relative;
    .date-container {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // margin-bottom: 10px * $zoom;
      //   border-radius: 16px * $zoom;
      //   border: 1px solid #3a8559;
      //   height: 30px * $zoom;
      // text-align: center;
    }
    .date-picker-ctrl {
      width: 0;
      height: 0;
      position: absolute;
      overflow: hidden;
      top: 0;
      left: 0;
    }
    .month-text {
      margin-right: 10px;
      font-size: 28px;
      font-weight: 400;
      color: #3d3d3d;
      display: flex;
      align-items: center;
      // margin-top: -45px;
      //   color: #018755;

      .date-icon {
        vertical-align: middle;
        font-size: 24px;
      }
    }
    .date_set {
      margin-left: 10px;
      display: flex;
      align-items: center;
      .date1 {
        font-size: 34px;
        font-weight: bold;
        color: #ccc;
      }
      .date2,
      .date3 {
        font-size: 34px;
        font-weight: bold;
        color: rgb(105, 104, 104);
      }
    }
  }
  .search_right {
    display: flex;
    align-items: center;
    font-size: 24px;
    .date1 {
      font-size: 24px;
      margin-right: 10px;
    }
  }
}
.content {
  // padding: 40px;
  box-sizing: border-box;
  // margin: 40px;
  .title {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
  }
  .con_list {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    margin-bottom: 80px;
    .text {
      //   margin-top: 10px;
      position: absolute;
      right: -8px;
      top: 50px;
      color: #999;
      font-size: 26px;
      //   margin-left: -8px;
    }
  }
  .no_box {
    // width: 2.02vw;
    // flex: 1;
    // width: calc((100vw - 80px) / 48);
    height: 40px;
    // border: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: none;
    box-sizing: border-box;
  }
  .new-class {
    background: rgb(156, 211, 248);
    opacity: 0.5;
    // border: 1px solid skyblue;
  }
  .ctime {
    background: rgba(78, 162, 124, 0.3);
    border-top: 1px solid rgba(78, 162, 124, 0.3);
    border-bottom: 1px solid rgba(78, 162, 124, 0.3);
  }
  .ztime {
    background: rgba(78, 162, 124, 1);
    border-top: 1px solid rgba(78, 162, 124, 1);
    border-bottom: 1px solid rgba(78, 162, 124, 1);
  }
  .jtime {
    background: rgba(50, 106, 251, 1);
    border-top: 1px solid rgba(50, 106, 251, 1);
    border-bottom: 1px solid rgba(50, 106, 251, 1);
  }
  .bClss {
    border-left: 1px solid #ccc;
  }
  .con_list div:last-child .no_box {
    border-right: 1px solid #ccc;
  }
  .menu {
    width: 100%;
    height: 1px;
    background: #ccc;
    margin-bottom: 60px;
  }
}
.content div:last-child .menu {
  height: 0;
}
.blue-box {
  position: absolute;
  border: 2px solid rgba(244, 137, 91, 1);
  background-color: rgba(244, 137, 91, 0.3);
}
.resize-handle-left,
.resize-handle-right {
  position: absolute;
  width: 10px;
  height: 100%;
  top: 0;
  cursor: ew-resize;
}
.resize-handle-left {
  left: -5px;
}
.circle {
  width: 15px; /* 小圆球的宽度 */
  height: 15px; /* 小圆球的高度 */
  background-color: #fff; /* 小圆球的背景颜色 */
  border-radius: 50%; /* 将方块变为圆形 */
  border: 2px solid rgba(244, 137, 91, 1);
  position: absolute; /* 绝对定位 */
  top: 50%; /* 顶部偏移50% */
  left: 50%; /* 左侧偏移50% */
  transform: translate(
    -50%,
    -50%
  ); /* 使用transform调整位置，确保小圆球完全居中 */
}
.resize-handle-right {
  right: -5px;
}

.ztimeMenu {
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 20px;
  font-size: 24px;
  .s1 {
    color: #3f58c7;
    font-weight: bold;
  }
}
.ctimeMenu {
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 20px;
  font-size: 24px;
  .s1 {
    color: #000;
    font-weight: bold;
  }
}

.reserv-btn {
  width: 100%;
  margin-top: 10px;
  color: #fff;
  background: rgba(50, 106, 251, 1);
  &.is-disabled {
    color: #c0c4cc;

    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
}
.d1 {
  margin-bottom: 20px;
  font-size: 24px;
  display: flex;
  align-items: center;
  span {
    margin-right: 20px;
    font-size: 24px;
  }
}
.d_btn {
  display: flex;
  justify-content: space-around;
  margin: 40px 0 20px;
  .btnBc,
  .btnCz {
    width: 160px !important;
  }
  .btnBc {
    background: rgba(50, 106, 251, 1);
    color: #fff;
  }
}
.con_menu {
  border: rgba(244, 137, 91, 1) 1px solid;
}
</style>
